<div class="wrapper">
  <div class="heading text-type-15">RFIs & SUBMITTALS</div>
  <div (click)="handleSectionClick()" class="content-section">
    <div class="text-type-8">
      <span class="label-bold">Open</span>
      <span class="details"> (</span>
      <span
        (click)="handleRfiClick(); $event.stopPropagation()"
        class="clickable-count">
        {{ rfiOpenCount }} {{ rfiOpenCount === 1 ? 'rfi' : 'rfis' }}
      </span>
      <span class="details"> & </span>
      <span
        (click)="handleSubmittalClick(); $event.stopPropagation()"
        class="clickable-count">
        {{ submittalOpenCount }} {{ submittalOpenCount === 1 ? 'submittal' : 'submittals' }}
      </span>
      <span class="details">)</span>
    </div>
  </div>
</div>
